import loadable from '@loadable/component';

export const UserDashboardEditEventPageContainerLoadable = loadable(
  () => import('./UserDashboardEditEventPageContainer'),
  { resolveComponent: (module) => module.UserDashboardEditEventPageContainer },
);
